import React, { useCallback, useEffect, useRef } from "react";

import { useProjectState } from "../../../hooks/useProjectState";
import { connect, useSelector } from "react-redux";
import MaterialTable from "@material-table/core";
import ProjectService from "../../../services/ProjectService";
import BimUserProjectObjects from "./BimUserProjectObjects";
import LoadingIndicator from "../../../shared/LoadingIndicator";
import {trackPromise} from "react-promise-tracker";
import {useState} from "react";
import { header } from'../../../shared/headerStyle';

const TOOLBAR_HEIGHT = 74;
const COLUMN_HEADER = 56;
const PAGINATION_HEIGHT = 52;
const TABS_HEIGHT = 60;
const PADDING = 24;

const katalogViewStyle = {
    width: "100%",
    height: "100%",
    float: "left",
};

const btListeStyle = {
    width: "100%",
    maxHeight: "100vh",
    float: "left",
};

function DataListView({projectList, setUserProject}) {
    const tableRef = useRef();
    const tableHeight = `calc(100vh - ${TOOLBAR_HEIGHT + COLUMN_HEADER + PAGINATION_HEIGHT + TABS_HEIGHT + PADDING}px)`;

    const handleClickOnRow = (project) => {
        setUserProject(project);
    };

    return (
        <MaterialTable
            tableRef={tableRef}
            title="Projekte"
            columns={[
                { title: 'Bezeichnung', field: 'name' },
                { title: 'Beschreibung', field: 'description' },
                { title: 'lesen', field: 'read', lookup: { false: 'nein', true: 'ja' } },
                { title: 'schreiben', field: 'write', lookup: { false: 'nein', true: 'ja' } },
                { title: 'Profil', field: 'bimProfileName' },
            ]}
            data={projectList}
            options={{
                headerStyle: header,
                actionsColumnIndex: -1,
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100],
                exportButton: true,
                exportAllData: true,
                maxBodyHeight: tableHeight,
                minBodyHeight: tableHeight,
            }}
            actions={[
                {
                    icon: 'wysiwyg',
                    tooltip: 'Daten erfassen',
                    onClick: (event, rowData) => handleClickOnRow(rowData)
                },
            ]}
            onRowClick={(event, rowData) => handleClickOnRow(rowData)}
            localization={{
                pagination: {
                    labelDisplayedRows: '{from}-{to} von {count}',
                    labelRowsSelect: 'Zeilen',
                    labelRowsPerPage: 'Zeilen pro Seite'
                },
                toolbar: {
                    nRowsSelected: '{0} Zeile(n) ausgewählt',
                    searchTooltip: 'Suchen',
                    searchPlaceholder: 'Suchbegriff eingeben'
                },
                header: {
                    actions: ''
                },
                body: {
                    emptyDataSourceMessage: 'Keine Einträge gefunden',
                    filterRow: {
                        filterTooltip: 'Filter'
                    },
                    editRow: {
                        deleteText: 'Soll der Datensatz wirklich gelöscht werden?',
                        saveTooltip: 'Speichern',
                        cancelTooltip: 'Abbrechen'
                    }
                }
            }}
        />
    );
}

function BimUserProjects({theRealm}) {
    const token = useSelector((state) => state.keycloakToken);
    const project = useProjectState();
    const bimUserProjects = project.userProjects;
    const setBimUserProjects = project.setUserProjects;
    const [userProject, setUserProject] = useState(null);

    const reloadProjects = useCallback(async () => {
        try {
            const result = await ProjectService.listmyprojects(token, theRealm);
            setBimUserProjects(result.data);
        } catch (e) {
            console.error('Fehler beim Laden der Projekte:', e);
        }
    }, [setBimUserProjects, theRealm, token]);

    useEffect(() => {
        trackPromise(reloadProjects());
    }, [reloadProjects]);

    return (
        <div>
            <LoadingIndicator />
            <div style={katalogViewStyle}>
                <div style={btListeStyle}>
                    {!userProject?.guid ? (
                        <DataListView projectList={bimUserProjects} setUserProject={setUserProject}/>
                    ) : (
                        <BimUserProjectObjects
                            userProject={userProject}
                            setUserProject={setUserProject}
                            projectGuid={userProject.guid}
                            realm={theRealm}
                            projectId={userProject.id}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

function mapState({theRealm}) {
    return {
        theRealm: theRealm
    };
}

export default connect(
    mapState,
    null
)(BimUserProjects);
